import { DeleteFilled, EnvironmentOutlined, LinkOutlined } from '@ant-design/icons'
import { GraviButton, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { InputNumber, Tooltip } from 'antd'
import React from 'react'
import useMediaQuery from 'use-media-antd-query'

import { useOrderContainersContext } from '../../../../Contexts/OrderContainersContext'

function cypressProps({ productName, compartmentIndex, targetIndex, dataCy }) {
  return {
    'data-product': productName,
    'data-compartment-index': compartmentIndex,
    'data-target-index': targetIndex,
    'data-cy': dataCy,
  }
}

function ManifoldIdRender({ id, compartmentLength }: { id?: string; compartmentLength: number }) {
  if (!id) return
  const screenSize = useMediaQuery()

  if (['xs', 'sm'].includes(screenSize) || (['md', 'lg'].includes(screenSize) && compartmentLength >= 3)) {
    return (
      <Tooltip
        overlay={
          <span
            style={{
              alignItems: 'center',
              gap: '0.25rem',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            }}
          >
            <LinkOutlined className='mr-1' />
            {id}
          </span>
        }
      >
        <LinkOutlined className='mr-1' />
        {id.slice(0, 20)}...
      </Tooltip>
    )
  }

  return (
    <span
      style={{
        display: 'inline-block',
        alignItems: 'center',
        gap: '0.25rem',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      <LinkOutlined className='mr-1' />
      {id}
    </span>
  )
}
export function ProductAllocatedPocket({ productName, compartment, targetIndex, editable }) {
  const { productGroupsApi } = useOrderContainersContext()
  const canEdit = editable
  const canDelete = editable
  const target = compartment?.targets?.[0]

  return (
    <Vertical className='bordered px-3 py-2' gap={8} style={{ minWidth: 230 }}>
      <Horizontal alignItems='center' style={{ gap: '1rem' }}>
        <Texto category='h6' style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', minWidth: 80 }}>
          <EnvironmentOutlined />
          {target?.location_name} (#{target.tank_id})
        </Texto>
        <ManifoldIdRender id={target.manifold_id} compartmentLength={productGroupsApi.compartments?.length} />
      </Horizontal>
      <Horizontal justifyContent='space-between'>
        <InputNumber
          {...cypressProps({
            productName,
            compartmentIndex: compartment.compartment_index,
            targetIndex,
            dataCy: 'productGroups-target-volumeInput',
          })}
          autoFocus
          style={{ minWidth: 110 }}
          min={0}
          value={compartment.targets[0]?.volume}
          disabled={!canEdit}
          onChange={(volume) => {
            // Ensure volume is an integer
            const parsedVolume = parseInt(volume, 10)
            // Check if the parsed volume is a valid integer
            if (!isNaN(parsedVolume)) {
              // Perform the adjustment only if the parsed volume is a valid integer
              productGroupsApi.adjustAllocationVolume(productName, targetIndex, parsedVolume)
            }
          }}
          placeholder='Enter Volume'
        />
        {canDelete && (
          <GraviButton
            {...cypressProps({
              productName,
              compartmentIndex: compartment.compartment_index,
              targetIndex,
              dataCy: 'productGroups-target-deleteButton',
            })}
            onClick={() => productGroupsApi.deleteProductGroupAllocation(productName, targetIndex)}
            className='container-clear-button'
            type='text'
            icon={<DeleteFilled />}
          />
        )}
      </Horizontal>
    </Vertical>
  )
}
